_getPaymentMethods